import { useState, useRef } from "react";

import Button from "../button";

import { scanPassport } from "api/Utilities";
import ScannerSound from "assets/scanner.mpeg";
import { useTranslation } from "i18n";
import PassportLoading from "./loading";

const PassportField = ({
  setErrImg,
  handlePassportResponse,
  onFileSelected,
  label,
  className,
}) => {
  const { t } = useTranslation();
  const hiddenFileInput = useRef(null);
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState("");
  const [fileType, setFileType] = useState("");

  const scanApi = async (result) => {
    setErrImg?.("");
    setLoading(true);
    var audio = new Audio(ScannerSound);
    audio.play();
    const response = await scanPassport({
      image: result,
    });
    if (response.ok) {
      const travelerData = response?.data?.data;
      handlePassportResponse(travelerData);
      onFileSelected?.(result);

      setLoading(false);
      audio.pause();
      audio.currentTime = 0;
    } else {
      setErrImg?.(response?.data?.errorDetails);
      setLoading(false);
      audio.pause();
      audio.currentTime = 0;
    }
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      setFileType(img.type);

      setImage(URL.createObjectURL(img));
      scanApi(img);
    }
  };

  return (
    <>
      <Button type="button" onClick={handleClick} className={className || "primary-color"}>
        {label || t("booking.existingTravelers.uploadPassport")}
      </Button>
      <input
        style={{ display: "none" }}
        type="file"
        name="myImage"
        accept="image/*,application/pdf"
        ref={hiddenFileInput}
        onChange={(event) => {
          onImageChange(event);
          event.target.value = "";
        }}
      />
      {loading && <PassportLoading image={image} fileType={fileType} />}
    </>
  );
};

export default PassportField;
